import { Text } from '@procurify/ui'
import styled from 'styled-components'

const TITLE_MAX_LINES = 2

export const CatalogItemTitleStyled = styled(Text)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
  /* A vendor title can run far past the card, so it wraps and then clamps. */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${TITLE_MAX_LINES};
  overflow: hidden;
  overflow-wrap: anywhere;
`
